import { render } from "./workpermitview.vue?vue&type=template&id=11973e8b&scoped=true"
import script from "./workpermitview.vue?vue&type=script&lang=js"
export * from "./workpermitview.vue?vue&type=script&lang=js"

import "./workpermitview.vue?vue&type=style&index=0&id=11973e8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11973e8b"]])

export default __exports__